import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { filterBoolean } from '@recruitee/common';
import { createEffectFactory } from '@recruitee/ngrx';

import { DevFlagsHttpService } from './dev-flags-http.service';
import { DevFlagActions } from './dev-flags.store';

@Injectable({ providedIn: 'root' })
export class DevFlagsEffects {
  public effects = createEffectFactory(DevFlagActions, this.actions$);

  public loadDevFlags$ = this.effects(DevFlagActions.fetch, () =>
    this.devFlagsHttpService.fetch().pipe(filterBoolean),
  );

  constructor(
    private actions$: Actions,
    private devFlagsHttpService: DevFlagsHttpService,
  ) {}
}
